exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.assign_summernote_item .note-editor.note-frame {\n  width: calc(70vw - 120px);\n}\n.assign_summernote_item {\n  padding-bottom: 10px;\n}\n.no_form_1 {\n  font-size: 30px;\n  text-align: center;\n  color: #acacac;\n  padding-top : 10px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1e0c4534","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ticket/TicketAssignDialog.vue
// module id = 795
// module chunks = 75